import Layout from "../pages/Layout/Layout";
import { Navigate, useParams } from "react-router-dom";

const Guardian = () => {
    let token = localStorage.getItem("supportTok");

    if (!token) {
        return <Navigate replace to={"/"} />
    }

    let dataToken = JSON.parse(atob(token.split(".")[1]));    
    let fechaExpiracion = dataToken.exp * 1000; // Convertir `exp` a milisegundos
    let ahora = Date.now(); // Obtener la fecha actual en milisegundos
    if (fechaExpiracion < ahora) {
        return <Navigate replace to={"/"} />;
    }

    return <Layout/>    
    
}

export default Guardian;